export default __webpack_public_path__ + "static/media/colors-768w.f5c3523e.avif";